import React from 'react';
import ContainerLogin from '../../components/Login/ContainerLogin';
import FooterLogin from '../../components/Login/FooterLogin';
import LogoLogin from '../../components/Login/LogoLogin';
import MainLogin from '../../components/Login/MainLogin';
import { MessageConfirmedEmail } from '../../components/Login/MessagesLogin';

export default function TemplatePage404() {
  return (
    <ContainerLogin>
      <MainLogin>
        <LogoLogin />
        <MessageConfirmedEmail>
          <h2>Ops... Nenhuma página foi encontrada!</h2>
        </MessageConfirmedEmail>
      </MainLogin>
      <FooterLogin />
    </ContainerLogin>
  );
}
